import { cn, formatFileSize } from "@repo/shared/utils";
import { DownloadIcon, XIcon } from "lucide-react";
import { InputInfo } from "./InputInfo";

export const FileDisplay = ({
  name,
  size,
  disabled = false,
  onDownload,
  onRemove,
  error,
  errorMessage,
}: {
  name: string;
  size: number;
  disabled?: boolean;
  onDownload?: () => void;
  onRemove?: () => void;
  error?: boolean;
  errorMessage?: string;
}) => {
  return (
    <div className="flex flex-col gap-y-3">
      <div className="bg-slate-100 flex flex-col border-2 py-4 text-center rounded-md transistion-all duration-200">
        <div
          id="uploadedFile"
          className="flex flex-row justify-between items-center gap-2 px-4"
        >
          {onDownload && (
            <button
              className="hover:scale-110 duration-200"
              onClick={onDownload}
              type="button"
            >
              <DownloadIcon />
            </button>
          )}
          <p
            className={onDownload ? "cursor-pointer" : ""}
            onClick={onDownload}
          >
            {name}
          </p>
          <div className="flex-grow" />
          <p>{formatFileSize(size)}</p>
          {onRemove && !disabled && (
            <button
              className={cn(
                "hover:scale-110 duration-200",
                disabled && "opacity-50"
              )}
              onClick={onRemove}
              type="button"
            >
              <XIcon />
            </button>
          )}
        </div>
      </div>
      {error && errorMessage && <InputInfo info={errorMessage} />}
    </div>
  );
};
